<template>
	<div class="manual" v-html="manual.text"></div>
</template>

<script>
import GuideService from '../../service/GuideService';

export default {
	data() {
		return {
			manual: { text: '' },
			service: new GuideService(),
		};
	},
	async mounted() {
		let {data} = await this.service.manual();
		this.manual = data;
	},
}
</script>

<style lang="scss" scoped>

.manual {
	width: 900px;
	margin: 0 auto;
	padding: 20px;
}

.accept-button {
	display: block;
	margin: 50px;
	margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/guide-manual/GuideManual.vue